BaseModel = require './base_model.coffee'

class global.TwilioSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    seconds_left: {}
    caller_id: ''
  }

  @SERIALIZABLE_ATTRIBUTES = ['id']

  @ASSOCIATIONS = {
    voip_monthly_plan: -> VoipMonthlyPlan
    voip_additional_times: -> VoipAdditionalTime
  }

  @SERIALIZABLE_ASSOCIATIONS = [
    'voip_monthly_plan'
    'voip_additional_times'
  ]

  sum_additional_minutes: ->
    return 0 if @voip_additional_times.length == 0
    (@voip_additional_times.map (m)-> m.seconds_in_minutes()).reduce((a, b) -> a + b)



// WEBPACK FOOTER //
// ./src/models/twilio_setting.coffee